/**
 * Shared progress types for agent progress tracking.
 * Used by both Deep Research and Data Capture agents.
 */

export enum ToolCallStatus {
  PENDING = 'pending',
  COMPLETED = 'completed',
}

/**
 * Represents a tool call in progress or completed.
 * This is the base interface used by both Deep Research and Data Capture.
 */
export interface ProgressToolCall {
  /** The tool name (can be an enum value or string for external tools) */
  tool: string;
  /** Unique identifier for this tool call */
  toolId: string;
  /** When the tool call was initiated */
  createdAt: Date;
  /** Current status of the tool call */
  status: ToolCallStatus;
  /** Human-readable display name for the tool */
  displayName: string;
  /** Optional tool arguments (used by Data Capture for detail display) */
  args?: Record<string, unknown>;
  /** Optional response text from the tool (used by Data Capture for detail display) */
  responseText?: string;
}

/**
 * Progress data containing tool call history.
 * Used for both in-progress and completed thinking sections.
 */
export interface ProgressData {
  toolCalls: Array<ProgressToolCall>;
}
